import { useEffect, useRef } from "react";

import { selectCurrentClassUser } from "store/selectors";
import { useObjectSelector } from "store/store-hooks";
import { AutoMuteService } from "utils/auto-mute-service";

/**
 * Unified hook that handles all auto-mute scenarios:
 * - Breakout room returns
 * - Any other future auto-mute triggers
 */
export const useUnifiedAutoMute = ({ isInVirtualClass }: { isInVirtualClass: boolean }) => {
  const currentClassUser = useObjectSelector(selectCurrentClassUser, [
    "breakout_group_id",
    "is_in_class_session",
    "listened_breakout_group_id",
  ]);
  const previousBreakoutGroupId = useRef<string | null>(null);

  // Handle breakout return auto-mute
  useEffect(() => {
    if (!isInVirtualClass) {
      return;
    }

    const currentBreakoutGroupId = currentClassUser?.breakout_group_id || null;

    const scenario = AutoMuteService.detectScenario(
      currentClassUser || null,
      previousBreakoutGroupId.current,
    );

    if (scenario === "breakout_return" || scenario === "breakout_listening") {
      AutoMuteService.handleAutoMute(scenario);
    }

    // Update the previous state for next comparison
    previousBreakoutGroupId.current = currentBreakoutGroupId;
    // All of the classUser properties we subscribe to should trigger this effect, so it is okay to disable the object deps warning.
    // eslint-disable-next-line @minervaproject/no-object-deps/no-object-deps
  }, [currentClassUser, isInVirtualClass]);
};
